import React, { Component } from "react";
import { arrayOf, bool, objectOf, shape, string } from "prop-types";

import LapseSubOption from "pages/forms/_components/_scheduler/LapseSubOption";
import { Row, Col } from "react-bootstrap";
import { Field } from "formik";
import DateField from "pages/_components/fields/DateField";
import * as schedulerUtils from "util/scheduler";
import Select from "pages/forms/_components/_fields/Select";
import * as i18nUtils from "util/i18n";
import I18n from "pages/_components/I18n";
import * as dateUtils from "util/date";
import moment from "moment";
import { getInteger } from "util/config";

const Mustache = require("mustache");

const FORM_ID = "scheduler";

const numberByFreq = {
    DAY: getInteger("time.frecuency.max.days", 365),
    WEEK: getInteger("time.frecuency.max.weeks", 42),
    MONTH: getInteger("time.frecuency.max.months", 12),
};
class CustomFrequencySubOption extends Component {
    static propTypes = {
        enabledWeekDays: arrayOf(bool),
        errors: objectOf(string),
        nonWorkingDays: arrayOf(bool),
        lapse: shape({
            day: string,
        }).isRequired,
        frequency: string.isRequired,
        startsOn: string.isRequired,
        customFreq: string,
    };

    static defaultProps = {
        errors: null,
        enabledWeekDays: [],
        nonWorkingDays: [],
        customFreq: "",
    };

    state = {
        occurrenceOptions: [],
    };

    componentDidMount() {
        const { startsOn } = this.props;
        this.onStartsChange(moment(startsOn.toDate()));
    }

    onStartsChange = (date) => {
        const perDayOption = Mustache.render(i18nUtils.get("scheduler.monthly.everyMonthOnDay"), {
            dayNumber: date.date(),
        });
        const occurrence = schedulerUtils.getOccurrenceWithWeekOfMonth(dateUtils.weekOfMonth(date));
        const perOccurrenceOption = Mustache.render(i18nUtils.get("scheduler.monthly.everyMonthOnRelativeDayOfaWeek"), {
            [occurrence]: true,
            day: date.format("dddd"),
        });

        this.setState({
            occurrenceOptions: [
                {
                    value: "day",
                    label: perDayOption,
                },
                {
                    value: "occurrence",
                    label: perOccurrenceOption,
                },
            ],
        });
    };

    obtainMaxDate = () => {
        const { lapse, customFreq } = this.props;
        const withLimits = [schedulerUtils.DAY, schedulerUtils.WEEK, schedulerUtils.MONTH];
        const hasLapse = lapse?.lapse === "UNTIL" && withLimits.includes(customFreq);
        return hasLapse ? lapse?.date : null;
    };

    render() {
        const { frequency, lapse, startsOn, enabledWeekDays, nonWorkingDays, errors, customFreq } = this.props;
        const { occurrenceOptions } = this.state;
        const options = Array.from({ length: numberByFreq[customFreq] }, (_, index) => ({
            value: `${index + 1}`,
            label: `${index + 1}`,
        }));
        const noYear = schedulerUtils.listEvery().filter((item) => item.value !== "YEAR");
        return (
            <>
                <Col sm={12} md={8} mdOffset={2}>
                    <Row>
                        <label className="font-weight-600">
                            <I18n id="scheduler.every" />
                        </label>
                        <Col sm={12} md={4}>
                            <div className="input-group">
                                <Field
                                    component={Select}
                                    name="customFreqValue"
                                    className="slideFromBottom"
                                    options={options}
                                    clearable={false}
                                    searchable={false}
                                />
                            </div>
                        </Col>
                        <Col sm={12} md={8}>
                            <div className="input-group">
                                <Field
                                    component={Select}
                                    name="customFreq"
                                    className="slideFromBottom"
                                    options={noYear}
                                    clearable={false}
                                    searchable={false}
                                />
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Col sm={12} md={8} mdOffset={2}>
                    <Field
                        component={DateField}
                        autoComplete="off"
                        idForm={FORM_ID}
                        name="startsOn"
                        minDate={dateUtils.setMidnight(startsOn)}
                        maxDate={this.obtainMaxDate()}
                        handleChange={this.onStartsChange}
                        dateFormat={dateUtils.FRIENDY_DATE_FORMAT(i18nUtils.getLang())}
                        noEdit
                    />
                </Col>
                {customFreq === schedulerUtils.MONTH && (
                    <Col sm={12} md={8} mdOffset={2}>
                        <div className="input-group">
                            <Field
                                component={Select}
                                name="occurrenceType"
                                className="slideFromBottom"
                                options={occurrenceOptions}
                                clearable={false}
                                searchable={false}
                            />
                        </div>
                    </Col>
                )}
                {frequency !== schedulerUtils.ONCE && (
                    <Col sm={12} md={8} mdOffset={2}>
                        <div className="scheduler-frequency-suboptions">
                            <Field
                                name="lapse"
                                component={LapseSubOption}
                                enabledWeekDays={enabledWeekDays}
                                errors={errors}
                                firstWorkingDate={startsOn}
                                nonWorkingDays={nonWorkingDays}
                                value={lapse}
                                frequency={frequency}
                            />
                        </div>
                    </Col>
                )}
            </>
        );
    }
}

export default CustomFrequencySubOption;
